import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';

const Layout: React.FC = () => {
  const { isSidebarCollapsed } = useStore(
    useShallow(state => ({
      isSidebarCollapsed: state.isSidebarCollapsed,
    }))
  );

  return (
    <div className='h-screen bg-background'>
      {/* Fixed Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 ${isSidebarCollapsed ? 'w-16' : 'w-52'} z-30 transition-all duration-300 overflow-y-auto overflow-x-hidden`}
      >
        <Sidebar />
      </div>
      {/* Main Content */}
      <div
        className={`${isSidebarCollapsed ? 'ml-16' : 'ml-52'} flex flex-col transition-all duration-300`}
      >
        <Header />
        <main className='flex-1 p-6 overflow-y-auto'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
